import { usePortfolioStore } from "../../../state/portfolio";
import { EthocaAlertQueue } from "../widgets/EthocaAlertQueue";
import { TC40MatchHeatmap } from "../widgets/TC40MatchHeatmap";

export function TransactionsView() {
  const portfolio = usePortfolioStore((s) => s.portfolio);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <TC40MatchHeatmap records={portfolio.tc40} />
      <EthocaAlertQueue alerts={portfolio.ethoca} merchants={portfolio.merchants} />
    </div>
  );
}
